<ion-header>
  <ion-toolbar>
    <ion-title>Update failed</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <pre class="report">{{ report }}</pre>
</ion-content>

<ion-footer class="ion-padding d-flex justify-content-end">
  <ion-button (click)="copy()" class="rounded" color="dark" data-test-id="update-error-copy" fill="outline">{{ copied ? 'Copied' : 'Copy all' }}</ion-button>
  <ion-button (click)="close()" class="rounded ml-2" data-test-id="update-error-close">Close</ion-button>
</ion-footer>
